var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('i',{staticClass:"op-icon",class:{ 'op-icon--fill': _vm.fill },style:(_setup.style),domProps:{"innerHTML":_vm._s(_setup.icon)},on:{"click":function($event){return _setup.emits('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }